import * as firebase from "firebase";

const config = {
  apiKey: "AIzaSyBVJLaZkXaBdLccvopbXlMsKvsaDeZj1sw",
  authDomain: "jozsef-images-webpage.firebaseapp.com",
  databaseURL: "https://jozsef-images-webpage.firebaseio.com",
  projectId: "jozsef-images-webpage",
  storageBucket: "jozsef-images-webpage.appspot.com",
  messagingSenderId: "466614438068",
};

firebase.initializeApp(config);

const database = firebase.database();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

export { firebase, googleAuthProvider, database as default };



// WEBPACK FOOTER //
// ./src/firebase/firebase.js